import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchDashboardSummary_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_dashboard_summary.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch dashboard summary failed:", error);
    return { error: "Fetch dashboard summary failed" };
  }
};
